import React, { useContext } from 'react';
import { FormikContextType } from 'formik';
import { IProcedure } from 'common/schema/Procedure';
import { ICreateRequestDto } from 'common/dto/RequestDto';
import { IRequest } from 'common/schema/request/Request';
import moment from 'moment';
import {
  useCurrentCitizen,
  useCurrentUser
} from 'client/components/auth/AuthModule';
import { ContextualRequestBag } from 'common/schema/contextual-value/ContextualValue';

export interface IRequestCompileContext {
  procedure: IProcedure;
  request: ICreateRequestDto;
  currentStep: number;
  setCurrentStep: (step: number) => void;
}

export const RequestCompileContext = React.createContext<
  IRequestCompileContext
>({
  procedure: undefined as any,
  request: undefined as any,
  currentStep: 0,
  setCurrentStep: (step: number) => {}
});

// TODO/LOW Gestire quando è `undefined`
export const useRequestCompileContext = () => {
  const context = useContext(RequestCompileContext);
  const citizen = useCurrentCitizen();
  const user = useCurrentUser();

  return {
    ...context,
    /**
     * Creiamo un'anteprima della richiesta per poter gestire il calcolo,
     * in anteprima, dei metadati contestuali
     */
    requestPreview: ({
      ...context.request,
      ...ContextualRequestBag({
        citizen,
        sentAt: moment().toDate(),
        siap: user?.siap
      })
    } as unknown) as IRequest
  };
};
